var _rect, _path, _rect2, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconCartSuccess = function SvgIconCartSuccess(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 208,
    height: 208,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 208,
    height: 208,
    rx: 104
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M92 80c0-6.627 5.372-12 12-12s12 5.373 12 12zm-8 0H72a4 4 0 0 0-4 4v56a4 4 0 0 0 4 4h64a4 4 0 0 0 4-4V84a4 4 0 0 0-4-4h-12c0-11.046-8.954-20-20-20s-20 8.954-20 20m8 16c0 6.628 5.372 12 12 12s12-5.372 12-12h8c0 11.046-8.954 20-20 20s-20-8.954-20-20z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    x: 115,
    y: 119,
    rx: 18
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#388E3C",
    d: "M132.999 150.334c-7.363 0-13.333-5.97-13.333-13.334s5.97-13.333 13.333-13.333 13.334 5.97 13.334 13.333-5.97 13.334-13.334 13.334m-1.33-8 9.429-9.428-1.886-1.886-7.543 7.542-3.771-3.771-1.885 1.886z"
  })));
};
export default SvgIconCartSuccess;